import React from 'react';
import GradientPreview from '../gradient-preview';
import CircleSlider from '../circle-slider';
const LinearGradientAnglePicker = ({
  value,
  background,
  isDarkTheme = false,
  onDragStart = undefined,
  onDrag = undefined,
  onDragEnd = undefined,
  onClick = undefined,
  onInputChange = undefined,
}) => (
  <div className="ws-ui-linear-gradient-angle-picker">
    <GradientPreview background={background} />
    <div className="ws-ui-linear-gradient-angle-picker__control">
      <CircleSlider
        angle={value}
        isDarkTheme={isDarkTheme}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
        onClick={onClick}
        onInputChange={onInputChange}
      />
    </div>
  </div>
);

LinearGradientAnglePicker.displayName = 'LinearGradientAnglePicker';

export default LinearGradientAnglePicker;
